import { Plan, PLAN_KEYS } from './plan.types';

export const PLANS: Plan[] = [
  {
    id: 1,
    slug: PLAN_KEYS.ESSENCIAL,
    name: 'Essencial',
    basePrice: 59,
    cremationPrice: 15,
    familyTombstonePrice: 45,
    enrollment: null,
  },
  {
    id: 2,
    slug: PLAN_KEYS.BEM_ESTAR,
    name: 'Bem Estar',
    basePrice: 84,
    cremationPrice: 15,
    familyTombstonePrice: 45,
    enrollment: null,
  },
  {
    id: 3,
    slug: PLAN_KEYS.BEM_SEGURO,
    name: 'Bem Seguro',
    basePrice: 84,
    cremationPrice: 15,
    familyTombstonePrice: 45,
    enrollment: null,
  },
  {
    id: 4,
    slug: PLAN_KEYS.MULTIASSISTENCIA,
    name: 'Multiassistência',
    basePrice: 149,
    cremationPrice: 0,
    familyTombstonePrice: 0,
    enrollment: null,
  },
  {
    id: 5,
    slug: PLAN_KEYS.NEO,
    name: 'Neo',
    basePrice: 59,
    cremationPrice: 15,
    familyTombstonePrice: 45,
    enrollment: {
      price: 100,
      discount_percentage: 25.0,
    },
  },
];

export const getPlans = () => {
  return PLANS;
};

export const getCurrentPlan = (planKey: string) => {
  return getPlans().find((plan) => plan.slug === planKey);
};
